import {firebase} from '../config/fbconfig';


var storageRef = firebase.storage().ref();
var metadata = {
    contentType: 'image/jpeg'
};
const db = firebase.firestore();

class Teams{

    static async ListAllUsers() {
        const snapshot = await db.collection('chromaUsers').get()
        return snapshot.docs.map(doc => doc.data());
    }
    static async addTeams(eventsData){
        
        var file1 = document.querySelector('input[id=team1]').files[0];
        let team1DownloadURL = ((eventsData.team1LogoURL !== '' && eventsData.team1LogoURL.length !== 0) ? eventsData.team1LogoURL : await this.UploadImage(file1));
        return new Promise((resolve, reject) => {
            let MyFinalData = {
                eventTeamName: eventsData.team1Name,
                team_logo:team1DownloadURL,
                team1LogoName: eventsData.team1LogoName,
                userId:sessionStorage.getItem('MyID'),
            }
            
            
            if(team1DownloadURL){
                db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).set({
                    team_logo: team1DownloadURL
                }, { merge: true });
            }
            db.collection('teams').add(MyFinalData).then(ref => {
                ref.set({
                    id: ref.id
                }, {
                    merge: true
                }).then(async() => {
                    const snapshot = await db.collection('teams').where('userId', '==', sessionStorage.getItem('MyID')).get()
                    return resolve(snapshot.docs.map(doc => doc.data()));
                }, (err) => {
                    return reject(err);
                })
            });
        });
    }

    static UploadImage(file){
        return new Promise((resolve, reject) => {
            var uploadTask = storageRef.child('images/' + file.name).put(file, metadata);
            uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
                function (snapshot) {
                    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    // console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        // console.log('Upload is paused');
                        break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        // console.log('Upload is running');
                        break;
                    default:
                        {

                        }
                    }
                },
                function (error) {
                    switch (error.code) {
                    case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;

                    case 'storage/canceled':
                        // User canceled the upload
                        break;

                    case 'storage/unknown':
                        // Unknown error occurred, inspect error.serverResponse
                        break;
                    default:
                        {

                        }
                    }
                },
                function () {
                    // Upload completed successfully, now we can get the download URL
                    uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                            resolve(downloadURL) ;
                    }) 
                })
                return uploadTask.snapshot.ref.getDownloadURL()
        });
        
    }

    static async getTeams() {
        const snapshot = await db.collection('teams').where('userId', '==', sessionStorage.getItem('MyID')).get()
        return snapshot.docs.map(doc => doc.data());
    }

    static async getTeamById(teamId) {
        const snapshot = await db.collection('teams').where('id', '==', teamId).get()
        return snapshot.docs.map(doc => doc.data());
    }

    static DeleteTeam(DataId) {
        return new Promise((resolve, reject) => {
            db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).update({
                eventHex1:'',
                eventHex2:''
            })
            db.collection('teams').doc(DataId).delete().then(async() => {
                const snapshot = await db.collection('Teams').get()
                return resolve(snapshot.docs.map(doc => doc.data()));
            }, (err) => {
                return reject(err);
            });
        })

    }

    static async UpdateTeam(DataId, Data) {
        console.log("teamId",DataId);
        console.log("data",Data);
        let team1logo = document.querySelector('input[id=EditTeam1Logo]').files[0];
        // let eventPhoto = document.querySelector('input[id=EditeventPhoto]').files[0];
        var Updateteam1LogoURL = ( team1logo == undefined ? Data.team1LogoURL : await this.UploadImage(team1logo) );
        // var UpdateEventPhotoURL = ( eventPhoto == undefined ? Data.eventPhotoURL : await this.UploadImage(eventPhoto) );
        //Data.team1LogoURL = Updateteam1LogoURL;
        
        return new Promise((resolve, reject) => {
            
            if(Data.teamName){
                db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).update({ 
                    eventTeamName: Data.teamName, 
                });
            }
            if(Updateteam1LogoURL){
                Data.team_logo = Updateteam1LogoURL;
                db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).update({
                    team_logo: Updateteam1LogoURL,
                });
             }

            db.collection('teams').doc(DataId).update(Data).then(async() => {
                const snapshot = await db.collection('teams').where('id', '==', sessionStorage.getItem('MyID')).get()
                return resolve(snapshot.docs.map(doc => doc.data()));
            }, (err) => {
                return reject(err);
            })
        })
    }

}
export default Teams